exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".rebounds .box{margin-right:.5rem}.rebounds .box:last-child{margin-right:0}@media (min-width:768px){.rebounds .rebound{min-height:13.5rem}}.rebounds .rebound .content{padding-bottom:1.5em;padding-top:1.5em}", ""]);

